export default __webpack_public_path__ + "static/Gotham-Book-ef7e55872a7be659217e975608439dc0.ttf";